module.exports = __webpack_public_path__ + "media/hyper/images/bg-pattern-light-76f84bb307e1cb63896a6ab492703eba.svg";